<!-- // 压合结构 -->
<template>
  <el-table
    border
    class="impedance-table impedance-stack"
    :data="list"
  >
    <!-- 使用层 -->
    <el-table-column prop="layer_name" :label="LANG.layerName.en"></el-table-column>
    <!-- 图形 -->
    <el-table-column
      width="500"
      :label="LANG.graph.en"
    >
      <template slot-scope="scope">
        <div :class="`impedance-stack__${scope.row.material_type}`">
          <div v-if="scope.row.material_type == 2">{{ scope.row.material_name }}</div>
        </div>
      </template>
    </el-table-column>
    <!-- 材料 -->
    <el-table-column prop="material" :label="LANG.material.en"></el-table-column>
    <!-- 规格 -->
    <el-table-column prop="material_properties" :label="LANG.materialProperties.en"></el-table-column>
    <!-- 压合厚度 -->
    <el-table-column
      prop="top_conductor_thick"
      :label="LANG.topConductorThick.en"
      :formatter="formatThickness"
    ></el-table-column>
  </el-table>
</template>

<script>
import { LANG } from './lang'

export default {
  props: {
    list: {
      type: Array,
      default: () => []
    }
  },
  
  data() {
    return {
      LANG
    }
  },

  methods: {
    formatThickness(row) {
      return `${row.total_thick}mm`
    }
  }
}
</script>